import React, { useContext, useState, useEffect, useRef } from 'react'
import openSocket from 'socket.io-client'
import { Button, useMediaQuery } from '@material-ui/core'
import { apiCall } from '../../common/api'
import PrimaryButton from '../../components/atoms/PrimaryButton'
import SecondaryButton from '../../components/atoms/SecondaryButton'
import ImageGallery from 'react-image-gallery'
import 'react-image-gallery/styles/css/image-gallery.css'
import BiddingCard from '../../components/molecules/Bidding/BiddingCard'
import './ProductView.css'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import { useHistory } from 'react-router-dom'
import {
    handleRedirectInternal,
    currencyFormat,
    dateFormatFront,
    useCustomMediaQuery,
} from '../../common/components'
import { bidSocketHandler, messageHandler } from '../Common/socketHandler'
import FavoriteCheckbox from '../../components/atoms/FavoriteCheckbox'
import CurrencyConverter from './CurrencyConverter'
import Popup from '../../components/organisms/Popup'
import { PhotoSwipeGallery } from 'react-photoswipe'
import 'react-photoswipe/lib/photoswipe.css'

// context
import CommonContext from '../../context/common/commonContext'
import AuthContext from '../../context/auth/authContext'
import AlertContext from '../../context/alert/alertContext'
import ReadMore from '../../components/atoms/ReadMore'
import BidHistory from '../../components/organisms/BidHistory'

function TabPanel(props) {
    const { children, value, index, html, ...other } = props

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box>
                    {html ? (
                        <span
                            dangerouslySetInnerHTML={{
                                __html: html,
                            }}
                        ></span>
                    ) : (
                        <span>{children}</span>
                    )}
                </Box>
            )}
        </div>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
}))

const useImageZoom = (maxZoom = 9, minZoom = 1, zoomStep = 1.1) => {
    const [zoom, setZoom] = useState(1)
    const [position, setPosition] = useState({ x: 0, y: 0 })
    const [isDragging, setIsDragging] = useState(false)
    const dragStart = useRef({ x: 0, y: 0 })
    const lastZoom = useRef(1)

    useEffect(() => {
        document.body.style.overflow = zoom !== 1 ? 'hidden' : ''
    }, [zoom])

    const clamp = (value, min, max) => Math.min(Math.max(value, min), max)

    const handleWheel = (e) => {
        e.preventDefault()
        e.stopPropagation()

        const delta = e.deltaY
        let newZoom = zoom

        if (delta < 0) newZoom = zoom * zoomStep
        else newZoom = zoom / zoomStep

        newZoom = clamp(newZoom, minZoom, maxZoom)

        if (newZoom < lastZoom.current) {
            setPosition({ x: 0, y: 0 })
        } else {
            setPosition((pos) => ({
                x: pos.x * (newZoom / lastZoom.current),
                y: pos.y * (newZoom / lastZoom.current),
            }))
        }

        lastZoom.current = newZoom
        setZoom(newZoom)
    }

    const handleMouseDown = (e) => {
        if (zoom <= 1) return
        e.preventDefault()
        setIsDragging(true)
        dragStart.current = { x: e.clientX - position.x, y: e.clientY - position.y }
    }

    const handleMouseMove = (
        e,
        containerWidth = window.innerWidth,
        containerHeight = window.innerHeight,
    ) => {
        if (!isDragging) return

        let newX = e.clientX - dragStart.current.x
        let newY = e.clientY - dragStart.current.y

        const maxX = ((zoom - 1) * containerWidth) / 2
        const maxY = ((zoom - 1) * containerHeight) / 2

        newX = clamp(newX, -maxX, maxX)
        newY = clamp(newY, -maxY, maxY)

        setPosition({ x: newX, y: newY })
    }

    const handleMouseUp = () => setIsDragging(false)

    const reset = () => {
        setZoom(1)
        setPosition({ x: 0, y: 0 })
        setIsDragging(false)
        lastZoom.current = 1
    }

    return {
        zoom,
        position,
        isDragging,
        handleWheel,
        handleMouseDown,
        handleMouseMove,
        handleMouseUp,
        reset,
    }
}
// includes both live / blind auction
const SingleAuction = ({
    product,
    images,
    downloadFile,
    setProduct,
    getProductView,
    hideBidding,
}) => {
    const authContext = useContext(AuthContext)
    const classes = useStyles()
    const alertContext = useContext(AlertContext)
    const { phrase } = useContext(CommonContext)
    const { setAlert } = alertContext
    const [value, setValue] = React.useState(0)
    const { user, responseStatus, clearResponse, saveSearch } = authContext
    const [productDescPopup, setProductDescPopup] = useState(false)
    const [isOpen, setOpen] = useState(false)

    let history = useHistory()
    const handleChange = (event, newValue) => {
        setValue(newValue)
    }
    const auctionFormat = new URLSearchParams(window.location.search).get('af')
    const isOutletAuction = auctionFormat === 'outlet' || product?.auction_format === 'outlet'
    const functionalityWarrantyLabel = phrase?.functionality_warranty || 'Functionality Warranty'
    const functionalityWarrantyRegularText =
        phrase?.functionality_warranty_regular ||
        'The functionality of all products is guaranteed. Non-functional items are eligible for return.'
    const functionalityWarrantyOutletText =
        phrase?.functionality_warranty_outlet ||
        'The functionality of all products is guaranteed unless otherwise stated.'
    const functionalityWarrantyText = isOutletAuction
        ? functionalityWarrantyOutletText
        : functionalityWarrantyRegularText

    const userRef = useRef(user)
    const productRef = useRef(product)
    useEffect(() => {
        userRef.current = user
        productRef.current = product
    })
    const socketHandler = (data, type) => {
        bidSocketHandler(
            data,
            type,
            userRef.current,
            productRef.current,
            phrase,
            setProduct,
            setAlert,
        )
    }
    const [zoomImageIndex, setZoomImageIndex] = useState(0)
    const zoom = useImageZoom()
    const [zoomImageSrc, setZoomImageSrc] = useState('')
    const [isFullscreen, setIsFullscreen] = useState(false)
    const [zoomOpen, setZoomOpen] = useState(false)
    const openZoom = (src, index) => {
        setZoomImageSrc(src)
        setZoomImageIndex(index)
        setZoomOpen(true)
        zoom.reset()
    }

    const isSmallDesktop = useMediaQuery('(max-width:1024px)')

    const toggleZoom = (e) => {
        if (e) e.stopPropagation()
        if (zoom.zoom === 1) {
            // simulate wheel zoom in one step
            zoom.handleWheel({
                deltaY: -300, // zoom in
                preventDefault: () => {},
                stopPropagation: () => {},
            })
        } else {
            // reset zoom
            zoom.reset()
        }
    }

    const goLeft = (e) => {
        if (e) e.stopPropagation()
        setZoomImageIndex((prev) => {
            const newIndex = prev === 0 ? galleryImages.length - 1 : prev - 1
            zoom.reset()
            return newIndex
        })
    }

    const goRight = (e) => {
        if (e) e.stopPropagation()
        setZoomImageIndex((prev) => {
            const newIndex = prev === galleryImages.length - 1 ? 0 : prev + 1
            zoom.reset()
            return newIndex
        })
    }

    useEffect(() => {
        if (!zoomOpen) return
        const handleKey = (e) => {
            if (e.key === 'ArrowLeft') goLeft()
            if (e.key === 'ArrowRight') goRight()
            if (e.key === 'Escape') closeZoom()
        }
        window.addEventListener('keydown', handleKey)
        return () => window.removeEventListener('keydown', handleKey)
    }, [zoomOpen])

    const closeZoom = (e) => {
        if (e) e.stopPropagation()
        setZoomOpen(false)
        setZoomImageSrc('')
        zoom.reset()
    }
    const toggleFullscreen = (e) => {
        if (e) e.stopPropagation()

        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen?.()
        } else {
            document.exitFullscreen?.()
        }
    }

    // Listen for fullscreen changes
    useEffect(() => {
        const handler = () => setIsFullscreen(Boolean(document.fullscreenElement))
        document.addEventListener('fullscreenchange', handler)
        return () => document.removeEventListener('fullscreenchange', handler)
    }, [])

    const galleryImages = images.map((img) => ({
        original: img.src || img.original || img,
        thumbnail: img.thumbnail || img.src || img.original || img,
        originalAlt: product.title,
        thumbnailAlt: product.title,
    }))
    useEffect(() => {
        if (zoomOpen) {
            document.body.style.overflow = 'hidden'
        } else {
            document.body.style.overflow = ''
        }
    }, [zoomOpen])
    const cancelBidHandler = (data) => {
        if (data.project_id == productRef.current.id) {
            getProductView(productRef.current.id)
        }
    }

    const productDescClose = () => {
        setProductDescPopup(false)
    }

    let options = {}

    useEffect(() => {
        const socket = openSocket(`${process.env.REACT_APP_DOMAIN}/`)
        socket.on('realclosedupdates', (data) => {
            socketHandler(data, 'realclosedupdates')
        })
        socket.on('bidAddtime', (data) => {
            socketHandler(data, 'bidAddtime')
        })
        socket.on('drop_price', (data) => {
            socketHandler(data, 'drop_price')
        })
        // Bid Cancellation Event => Reload the product info
        socket.on('cancelbidemitted', function (data) {
            cancelBidHandler(data)
        })
        socket.on('reservepriceupdate', function (data) {
            socketHandler(data, 'reservepriceupdate')
        })
        socket.on('bid_extended', function (data) {
            socketHandler(data, 'bid_extended')
        })
        return () => {
            socket.off('realclosedupdates', (data) => {
                socketHandler(data, 'realclosedupdates')
            })
            socket.off('bidAddtime', (data) => {
                socketHandler(data, 'bidAddtime')
            })
            socket.off('drop_price', (data) => {
                socketHandler(data, 'drop_price')
            })
            socket.off('cancelbidemitted', function (data) {
                cancelBidHandler(data)
            })
            socket.off('reservepriceupdate', function (data) {
                socketHandler(data, 'reservepriceupdate')
            })
            socket.off('bid_extended', function (data) {
                socketHandler(data, 'bid_extended')
            })
            socket.disconnect()
        }
    }, [])
    const getConditionPhrase = (itemcondition, phrase) => {
        switch (itemcondition) {
            case 1:
                return phrase?.new_cond_content || ''
            case 3:
                return phrase?.used_working_cond_content || ''
            case 4:
                return phrase?.open_box_new_cond_content || ''
            case 29:
                return phrase?.as_is_cond_content || ''
            default:
                return ''
        }
    }
    let categories = ''
    if (product) {
        for (let i in product.multiplecategoryshow) {
            // last index
            if (i == product.multiplecategoryshow.length - 1) {
                categories += phrase[product.multiplecategoryshow[i]]
            } else {
                categories += phrase[product.multiplecategoryshow[i]] + ', '
            }
        }
    }
    const redirectFile = (event) => {
        if (event.target.alt !== 'img') {
            window.location.href = `${global.site_url}/uploads/product/${event.target.title}`
        } else {
            event.preventDefault()
            setOpen(true)
        }
    }

    return (
        <div
            className={`auctionView container-fluid mt-2 mb-4 image-zoom-overlay ${
                isOutletAuction ? 'outlet' : ''
            }`}
        >
            <div className="customContainer">
                <div className="d-flex justify-content-start">
                    <Button className="backBtn my-2" onClick={() => history.goBack()}>
                        <span className="material-icons">arrow_back</span>Back
                    </Button>
                </div>
                <div className="row mb-4">
                    <div className="col-lg-8 col-md-12 col-12">
                        <div className="d-flex flex-column justify-content-start mb-3">
                            <div>
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-12 ">
                                        {user.isBuyer && product.isclosed >= 0 ? (
                                            <FavoriteCheckbox
                                                watchlisted={product.isWatchlisted}
                                                project_id={product.id}
                                            />
                                        ) : null}

                                        <ImageGallery
                                            items={galleryImages}
                                            thumbnailPosition="bottom"
                                            showNav={false}
                                            showBullets={false}
                                            showFullscreenButton={false}
                                            showPlayButton={false}
                                            autoPlay={true}
                                            lazyLoad={true}
                                            renderItem={(item) => (
                                                <div
                                                    className="image-gallery-image"
                                                    style={{ textAlign: 'center' }}
                                                >
                                                    <img
                                                        src={item.original}
                                                        alt={item.originalAlt}
                                                        style={{
                                                            cursor: 'zoom-in',
                                                            maxWidth: '100%',
                                                            maxHeight: '80vh',
                                                            objectFit: 'contain',
                                                        }}
                                                        onClick={() =>
                                                            openZoom(
                                                                item.original,
                                                                galleryImages.indexOf(item),
                                                            )
                                                        }
                                                    />
                                                </div>
                                            )}
                                        />
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-12  pvInfo">
                                        <h2 className="pvTitle"> {product.title} </h2>
                                        <label className="aboveredLine">{phrase.description}</label>
                                        <div className="redLine"></div>

                                        <div className="newPvGrid">
                                            <div className="pvGrid">
                                                <label> {phrase.manufacturer}</label>
                                                <span> {product.manufacturer} </span>
                                            </div>
                                            <div className="pvGrid">
                                                <label> {phrase.location} </label>
                                                <span> {product.country} </span>
                                            </div>
                                            <div className="pvGrid">
                                                <label>Model</label>
                                                <span>{product.modelnumber}</span>
                                            </div>
                                            <div className="pvGrid">
                                                <label> {phrase.category} </label>
                                                <span> {categories} </span>
                                            </div>
                                            <div className="pvGrid">
                                                <label>Size</label>
                                                <span> {product.size} </span>
                                            </div>
                                            <div className="pvGrid">
                                                <label> {phrase.condition} </label>
                                                <span>
                                                    {phrase[product.condition]
                                                        ? phrase[product.condition]
                                                        : product.condition}
                                                </span>
                                            </div>
                                            <div className="pvGrid">
                                                <label>Quantity</label>
                                                <span> {product.qty} </span>
                                            </div>
                                        </div>

                                        {/* <div className="pvGrid">
                            <div className="pvGrid">
                                <label> {phrase.lot_size} </label>
                                <span>
                                    {phrase[product.lottype]} {phrase.lot}
                                </span>
                            </div>
                            <div className="pvGrid">
                                <label> {phrase.auction_type} </label>
                                <span>
                                    {product.auctiontype == 'live'
                                        ? phrase.live_auction
                                        : product.auctiontype == 'lineitem'
                                        ? phrase.line_item_auction
                                        : phrase.blind_auction}{' '}
                                </span>
                            </div>
                        </div> */}

                                        {/* <div className="pvGrid">
                            <div className="pvGrid">
                                <label>UPC/SKU</label>
                                <span>{product.upc}</span>
                            </div>
                        </div> */}

                                        {/* <div className="pvGrid">
                            <div className="pvGrid">
                                <label>{phrase.finish}</label>
                                <span>{product.finish}</span>
                            </div>
                        </div> */}

                                        {/* <div className="pvDesc sdsd">
                            <label> {phrase.description} </label>
                            <ReadMore
                                limit={50}
                                data={product.desc_proc}
                                setHTML={true}
                                buttonText={phrase.view_more}
                                readMoreFunction={setProductDescPopup}
                            />
                        </div> */}
                                        {/* <p
                                dangerouslySetInnerHTML={{
                                    __html:
                                        product.desc_proc.length > 150
                                            ? product.desc_proc.substring(0, 150)
                                            : product.desc_proc,
                                }}
                            ></p>
                            {product.desc_proc.length > 150 ? (
                                <a className="font-25" onClick={() => setProductDescPopup(true)}>
                                    {phrase.view_more}
                                </a>
                            ) : null} */}
                                    </div>
                                </div>
                            </div>
                            <div className="lotDetails mt-3">
                                {product.currencyexist ? (
                                    <CurrencyConverter product={product} />
                                ) : null}

                                {product.auction_details && product.auction_details !== '' && (
                                    <>
                                        <label
                                            className="aboveredLine"
                                            style={{ fontSize: '19px' }}
                                        >
                                            {phrase.auction_details}
                                        </label>
                                        <div className="redLine"></div>
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: product.auction_details,
                                            }}
                                        />
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-8 col-12 biddingCardCnt">
                        {hideBidding ? (
                            ''
                        ) : (
                            <BiddingCard
                                product={product}
                                phrase={phrase}
                                setProduct={setProduct}
                                user={user}
                            />
                        )}
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-8 col-md-12 col-12">
                        <h2> {phrase.lot_details} </h2>
                        <div className="customTabs ledCustomTabs">
                            <AppBar position="static">
                                <Tabs
                                    value={value}
                                    onChange={handleChange}
                                    indicatorColor="primary"
                                    textColor="primary"
                                    variant="scrollable"
                                    scrollButtons="auto"
                                    allowScrollButtonsMobile
                                    aria-label="Product Information"
                                >
                                    <Tab label={phrase.products_description} {...a11yProps(0)} />
                                    <Tab label={phrase.condition} {...a11yProps(1)} />
                                    <Tab label={phrase.faq} {...a11yProps(2)} />
                                    {/* <Tab label={phrase.shipping} {...a11yProps(3)} />
                                    <Tab label={phrase.payment_note} {...a11yProps(4)} /> */}
                                    <Tab label={functionalityWarrantyLabel} {...a11yProps(3)} />
                                </Tabs>
                                {product.document ? (
                                    <div>
                                        <SecondaryButton onClick={downloadFile}>
                                            <span
                                                className="material-icons"
                                                style={{ marginRight: '3px' }}
                                            >
                                                cloud_download
                                            </span>{' '}
                                            {phrase.download_manfiest}
                                        </SecondaryButton>
                                    </div>
                                ) : null}
                            </AppBar>
                            <TabPanel value={value} index={0}>
                                <h6 className="lotCount">
                                    {phrase.showing} {product.csvResult} {phrase.of}{' '}
                                    {product.csvLength} {phrase.products}
                                </h6>
                                <table className="table mobileTable saTable table-striped">
                                    <thead className="thead-dark">
                                        <tr>
                                            <th scope="col">{phrase.brand}</th>
                                            <th scope="col">{phrase.product_name}</th>
                                            <th scope="col">{phrase.category}</th>
                                            <th scope="col">{phrase.part_number}</th>
                                            <th scope="col">{phrase.qty}</th>
                                        </tr>
                                    </thead>

                                    {product.csvData == '' ? (
                                        <tbody>
                                            <tr>
                                                <td colSpan="5" className="text-center">
                                                    {phrase.no_line_items_available}
                                                </td>
                                            </tr>
                                        </tbody>
                                    ) : (
                                        <tbody
                                            className="mtInner"
                                            dangerouslySetInnerHTML={{
                                                __html: product.csvData,
                                            }}
                                        ></tbody>
                                    )}
                                </table>
                                {product.document && product.market_status == 'open' ? (
                                    <div style={{ textAlign: 'center' }}>
                                        <PrimaryButton onClick={downloadFile} width="40%">
                                            <span
                                                className="material-icons"
                                                style={{ marginRight: '3px' }}
                                            >
                                                cloud_download
                                            </span>{' '}
                                            {phrase.download_manfiest}
                                        </PrimaryButton>
                                    </div>
                                ) : null}
                            </TabPanel>
                            <TabPanel
                                value={value}
                                index={1}
                                html={getConditionPhrase(product?.itemcondition, phrase)}
                            />
                            <TabPanel value={value} index={2} html={product.faqContent}></TabPanel>
                            <TabPanel value={value} index={3}>
                                {functionalityWarrantyText}
                            </TabPanel>
                            {/* <TabPanel
                                value={value}
                                index={3}
                                html={
                                    product.buyership == 1
                                        ? phrase.productview_1
                                        : product.shipping_service
                                }
                            >
                                {product.buyership == 1
                                    ? phrase.productview_1
                                    : product.shipping_service}
                            </TabPanel>
                            <TabPanel value={value} index={4} html={phrase.payment_note_details} /> */}
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-12 col-12">
                        <div
                            style={{ marginTop: '34px' }}
                            dangerouslySetInnerHTML={{ __html: product.auction_notes }}
                        />
                    </div>
                </div>
                {/* {product.auctiontype == 'lineitem' ? null : ( */}

                {/* )} */}
            </div>
            {/* <div className="row">
                <div className="col-md-12 assuranceCnt">
                    <div className="customContainer ">
                        <div className="row">
                            <div className="col-lg-8 col-12">
                                <div className="assuranceCard d-flex justify-content-between">
                                    <span className="material-icons">verified</span>
                                    <div>
                                        <h2>{phrase.buy_with_confidence}</h2>
                                        <p>{phrase.productview_2}</p>
                                        <p>{phrase.productview_3}</p>
                                        <p>{phrase.productview_4}</p>
                                        <span className="leaf">
                                            <span className="material-icons">eco</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

            {/* Long Product Description Modal*/}
            <Popup
                open={productDescPopup}
                modaltitle={phrase.description}
                handleClose={productDescClose}
                footer={<SecondaryButton label={phrase.close} onClick={productDescClose} />}
            >
                <div
                    style={{ textAlign: 'left' }}
                    dangerouslySetInnerHTML={{
                        __html: product.desc_proc,
                    }}
                ></div>
            </Popup>
            <BidHistory
                user={userRef.current}
                type={product.auctiontype}
                marketStatus={product.market_status}
            />
            {zoomOpen && (
                <div
                    className="image-zoom-overlay"
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        background: 'rgba(0,0,0,0.97)',
                        zIndex: 9999,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        overflow: 'hidden',
                    }}
                    onClick={closeZoom}
                    onWheel={zoom.handleWheel}
                >
                    <Button
                        onClick={(e) => {
                            e.stopPropagation()
                            closeZoom()
                        }}
                        style={{
                            position: 'absolute',
                            top: 'clamp(15px, 4vh, 30px)',
                            right: 'clamp(15px, 4vh, 30px)',
                            width: '50px',
                            minWidth: '50px',
                            height: '50px',
                            borderRadius: '50%',
                            background: 'rgb(255 255 255 / 12%)',
                            color: '#ffffffff',
                            fontSize: '28px',
                            fontWeight: 'bold',
                            boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
                            zIndex: 10001,
                        }}
                    >
                        <span className="material-icons">close</span>
                    </Button>
                    <Button
                        onClick={(e) => {
                            e.stopPropagation()
                            toggleFullscreen(e)
                        }}
                        style={{
                            position: 'absolute',
                            top: 'clamp(15px, 4vh, 30px)',
                            right: 'clamp(15px, 15vh, 90px)',
                            width: '50px',
                            minWidth: '50px',
                            height: '50px',
                            borderRadius: '50%',
                            background: 'rgb(255 255 255 / 12%)',
                            color: '#ffffffff',
                            fontSize: '28px',
                            fontWeight: 'bold',
                            boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
                            zIndex: 10001,
                        }}
                    >
                        <span className="material-icons">
                            {isFullscreen ? 'fullscreen_exit' : 'fullscreen'}
                        </span>
                    </Button>
                    <Button
                        onClick={toggleZoom}
                        style={{
                            position: 'absolute',
                            top: 'clamp(15px, 4vh, 30px)',
                            right: 'clamp(15px, 25vh, 150px)',
                            minWidth: '50px',
                            width: '50px',
                            height: '50px',
                            borderRadius: '50%',
                            background: 'rgb(255 255 255 / 12%)',
                            color: '#fff',
                            fontSize: '28px',
                            fontWeight: 'bold',
                            boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
                            zIndex: 10001,
                        }}
                    >
                        <span className="material-icons">
                            {zoom.zoom === 1 ? 'zoom_in' : 'zoom_out'}
                        </span>
                    </Button>

                    <img
                        src={galleryImages[zoomImageIndex]?.original || zoomImageSrc}
                        alt="Zoomed"
                        onClick={(e) => e.stopPropagation()}
                        onWheel={zoom.handleWheel}
                        onMouseDown={zoom.handleMouseDown}
                        onMouseMove={zoom.handleMouseMove}
                        onMouseUp={zoom.handleMouseUp}
                        onMouseLeave={zoom.handleMouseUp}
                        draggable={false}
                        style={{
                            maxWidth: '100vw',
                            maxHeight: '100vh',
                            objectFit: 'contain',
                            transform: `translate(${zoom.position.x}px, ${zoom.position.y}px) scale(${zoom.zoom})`,
                            transformOrigin: 'center center',
                            transition: zoom.isDragging ? 'none' : 'transform 0.15s ease-out',
                            userSelect: 'none',
                            flex: 1,
                            cursor:
                                zoom.zoom > 1
                                    ? zoom.isDragging
                                        ? 'grabbing'
                                        : 'grab'
                                    : 'zoom-out',
                        }}
                    />

                    <div
                        style={{
                            position: 'absolute',
                            bottom: `calc(100% - 93%)`,
                            left: 0,
                            right: 0,
                            height: '90px',
                            background:
                                isSmallDesktop && 'linear-gradient(transparent, rgba(0,0,0,0.8))',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '30px',
                            zIndex: 10000,
                            paddingBottom: 'env(safe-area-inset-bottom)',
                        }}
                        className="mobile-only"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <Button
                            onClick={(e) => {
                                e.stopPropagation()
                                goLeft()
                                if (navigator.vibrate) navigator.vibrate(30)
                            }}
                            style={{
                                width: '64px',
                                height: '64px',
                                borderRadius: '50%',
                                background: 'rgba(255, 255, 255, 0.95)',
                                color: '#000',
                                fontSize: '36px',
                                fontWeight: 'bold',
                                boxShadow: '0 8px 25px rgba(0,0,0,0.6)',
                                display: window.innerWidth <= 768 ? 'flex' : 'none',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <span className="material-icons">keyboard_backspace</span>
                        </Button>

                        <div
                            style={{
                                color: '#fff',
                                fontSize: '14px',
                                textAlign: 'center',
                                opacity: 0.9,
                                display: window.innerWidth <= 768 ? 'block' : 'none',
                            }}
                        >
                            {zoomImageIndex + 1} / {galleryImages.length}
                        </div>

                        <Button
                            onClick={(e) => {
                                e.stopPropagation()
                                goRight()
                                if (navigator.vibrate) navigator.vibrate(30)
                            }}
                            style={{
                                width: '64px',
                                height: '64px',
                                borderRadius: '50%',
                                background: 'rgba(255, 255, 255, 0.95)',
                                color: '#000',
                                fontSize: '36px',
                                transform: 'rotate(180deg)',
                                fontWeight: 'bold',
                                boxShadow: '0 8px 25px rgba(0,0,0,0.6)',
                                display: window.innerWidth <= 768 ? 'flex' : 'none',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <span className="material-icons">keyboard_backspace</span>
                        </Button>
                    </div>

                    {window.innerWidth > 768 && (
                        <>
                            <Button
                                onClick={(e) => {
                                    e.stopPropagation()
                                    goLeft()
                                }}
                                style={{
                                    position: 'absolute',
                                    left: 'clamp(15px, 5vw, 30px)',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    width: '56px',
                                    minWidth: '56px',
                                    height: '56px',
                                    borderRadius: '50%',
                                    background: 'rgba(127, 102, 102, 0)',
                                    color: '#ffffffff',
                                    fontSize: '32px',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
                                    zIndex: 10001,
                                }}
                            >
                                <span className="material-icons">keyboard_backspace</span>
                            </Button>
                            <Button
                                onClick={(e) => {
                                    e.stopPropagation()
                                    goRight()
                                }}
                                style={{
                                    position: 'absolute',
                                    right: 'clamp(15px, 5vw, 30px)',
                                    top: '50%',
                                    transform: 'translateY(-50%) rotate(180deg)',
                                    minWidth: '56px',
                                    width: '56px',
                                    height: '56px',
                                    borderRadius: '50%',
                                    background: 'rgba(255, 255, 255, 0)',
                                    color: '#ffffffff',
                                    fontSize: '32px',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
                                    zIndex: 10001,
                                }}
                            >
                                <span className="material-icons">keyboard_backspace</span>
                            </Button>
                        </>
                    )}
                </div>
            )}
        </div>
    )
}

export default SingleAuction
